import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/oportunidades/[slug]/ApplyButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/oportunidades/[slug]/FavoriteButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/oportunidades/[slug]/ShareButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RegistrationGate"] */ "/vercel/path0/components/auth/RegistrationGate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/vercel/path0/components/shared/Navbar.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
